// src/components/PlanetBox.js
import React, { useEffect } from 'react';
import $ from 'jquery';
import Airplane3D from './components/Airplane3D/Airplane3D';
import './PlanetBox.css';

const PlanetBox = () => {
  return (
    <div style={{ height: '80vh'}}>
      <Airplane3D />
    </div>
  );
};

export default PlanetBox;
